<template>
  <div class="loader-container">
    <svg width="0" height="0">
      <defs>
        <linearGradient id="loader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#b0bec5" />
          <stop offset="50%" stop-color="#90a4ae" />
          <stop offset="100%" stop-color="#78909c" />
        </linearGradient>
      </defs>
    </svg>
    <v-progress-circular
      indeterminate
      size="64"
      width="4"
      class="gradient-spinner"
    />
    <p class="loader-text mt-3">Loading video...</p>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style scoped>
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.loader-text {
  color: #888;
  font-size: 0.9rem;
}
.gradient-spinner >>> .v-progress-circular__overlay {
  stroke: url(#loader-gradient);
}
</style>
